var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 15.2067C6.00287 14.7643 4.65988 13.8095 3.596 12.3423C2.532 10.875 2 9.23463 2 7.42113V3.10581L7.625 1L13.25 3.10581V7.42113C13.25 9.23463 12.718 10.875 11.654 12.3423C10.5901 13.8095 9.24713 14.7643 7.625 15.2067ZM7.625 14.0211C8.925 13.6086 10 12.7836 10.85 11.5461C11.7 10.3086 12.125 8.93363 12.125 7.42113V3.87738L7.625 2.197L3.125 3.87738V7.42113C3.125 8.93363 3.55 10.3086 4.4 11.5461C5.25 12.7836 6.325 13.6086 7.625 14.0211Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/Compliance.5dce93ff2dd73dfc5f06d92b3b614ca9.svg";
export { ForwardRef as ReactComponent };